exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".instructions {\n  font-family: \"Source Sans Pro\", \"Helvetica Neue\", \"Helvetica\";\n  font-size: 1em;\n  color: #365e63;\n  text-align: right;\n  letter-spacing: normal;\n  word-spacing: normal;\n}\n\n.instructions-spacing {\n  margin-top: -40px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/sass-loader/lib/loader.js!./src/js/components/Instructions/instructions.scss
// module id = 256
// module chunks = 0